module.exports = "<!--<iframe #iFrame id=\"homeIframe\" (load)=\"onIframeLoad()\" frameborder=\"0\" class=\"entityIframe\" [src]=\"gwtSurveyhUrl\"></iframe>-->\n<div class=\"question-wrapper\" *ngIf=\"entityIdDetails.entityId\">\n    <div class=\"mt-base-double\">\n        <surveylist [entityIdDetails]=\"entityIdDetails\"></surveylist>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/surveys/entity-surveys.component.html
// module id = 2267
// module chunks = 0